module.exports = __webpack_public_path__ + "static/img/360.37be6fe.png";